export default __webpack_public_path__ + "static/media/leaflet.86936a8d.png";